import { useRegisterSW } from 'virtual:pwa-register/react';
import { createPortal } from 'react-dom';

function ReloadPrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    immediate: true,
    onRegistered(r: ServiceWorkerRegistration | undefined) {
      console.log('SW Registered: ' + r);
      // Check for updates every 60 seconds
      if (r) {
        setInterval(() => {
          r.update();
        }, 60 * 1000);
      }
    },
    onRegisterError(error: unknown) {
      console.log('SW registration error', error);
    },
  });

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  const showToast = offlineReady || needRefresh;

  if (!showToast) return null;

  // Use Portal to render directly into document.body, bypassing any parent transforms
  return createPortal(
    <div
      className="fixed top-4 right-4 p-4 pr-10 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 flex flex-col gap-2 max-w-sm"
      style={{ zIndex: 99999, position: 'fixed' }}
    >
      {/* Close X Button */}
      <button
        className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-100 transition-colors"
        onClick={close}
        aria-label="Close"
        style={{ position: 'absolute' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div className="text-sm text-gray-700 dark:text-gray-200">
        {offlineReady ? (
          <span>App ready to work offline</span>
        ) : (
          <span>New content available, click on reload button to update.</span>
        )}
      </div>
      <div className="flex gap-2 justify-end mt-2">
        {needRefresh && (
          <button
            className="px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium rounded transition-colors"
            onClick={() => {
              updateServiceWorker(true);
              // Fallback: force reload after a short delay if SW update doesn't trigger it
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }}
          >
            Reload
          </button>
        )}
      </div>
    </div>,
    document.body
  );
}

export default ReloadPrompt;
